// extracted by css-extract-rspack-plugin
export default {"chats":"chats-OJb2IY","loader":"loader-DKz07G","nextLoader":"nextLoader-NZKleE","empty":"empty-B5m0r7"};